var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verification-code-wrapper"},[_c('code-input',{ref:"code-input",staticClass:"input",attrs:{"type":"number","id":"codeInput","fields":_vm.length},on:{"change":_vm.onChange,"complete":_vm.onComplete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }